import { FC, ReactNode } from "react";
import { Heading } from "@otrium/atoms";
import { Trans } from "@lingui/macro";
import { Card } from "./CreateAccountBlock.styled";

interface CreateAccountBlockProps {
  children: ReactNode;
  as?: "h2" | "h3";
  variant?: "h3" | "h4";
  className?: string;
  "data-testid"?: string;
}

const CreateAccountBlock: FC<CreateAccountBlockProps> = ({
  children,
  as = "h2",
  variant = "h4",
  className,
  ...rest
}) => (
  <Card className={className} data-testid={rest["data-testid"]}>
    <Heading as={as} variant={variant}>
      <Trans>sign_up_checkout.create_account</Trans>
    </Heading>
    {children}
  </Card>
);

export { CreateAccountBlock };
